import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 钱包
 */
const balance = {

  /**
   * 查询个人钱包余额
   */
  getPersonalBalance () {
    return axios.post(base.balance.getPersonalBalance, utils.postParamsArrayToJsonString({}))
  },
  /**
   * 查询公司钱包余额
   */
  getCompanyBalance (companyId) {
    return axios.post(base.balance.getCompanyBalance, utils.postParamsArrayToJsonString({ companyId }))
  },
  /**
   * 查询个人余额变更记录
   */
  getPersonalBalanceChangingLog (startTime, endTime) {
    return axios.post(base.balance.getPersonalBalanceChangingLog, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },
  /**
   * 查询个人近期余额变更记录
   * @param {*} limit 
   * @returns 
   */
  getPersonalBalanceChangingLogRecent (limit) {
    return axios.post(base.balance.getPersonalBalanceChangingLogRecent, utils.postParamsArrayToJsonString({ limit }))
  },
  /**
   * 查询公司余额变更记录
   */
  getCompanyBalanceChangingLog (companyId, startTime, endTime) {
    return axios.post(base.balance.getCompanyBalanceChangingLog, utils.postParamsArrayToJsonString({ companyId, startTime, endTime }))
  },
  /**
   * 查询公司近期余额变更记录
   */
  getCompanyBalanceChangingLogRecent (companyId, limit) {
    return axios.post(base.balance.getCompanyBalanceChangingLogRecent, utils.postParamsArrayToJsonString({ companyId, limit }))
  },
  /**
   * 查询个人历史充值订单
   */
  getPersonalBalanceTopUpOrder (startTime, endTime) {
    return axios.post(base.balance.getPersonalBalanceTopUpOrder, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },
  /**
   * 查询个人近期充值订单
   */
  getPersonalBalanceTopUpOrderRecent (limit, status) {
    return axios.post(base.balance.getPersonalBalanceTopUpOrderRecent, utils.postParamsArrayToJsonString({ limit, status }))
  },
  /**
   * 查询公司历史充值订单
   */
  getCompanyBalanceTopUpOrder (companyId, startTime, endTime) {
    return axios.post(base.balance.getCompanyBalanceTopUpOrder, utils.postParamsArrayToJsonString({ companyId, startTime, endTime }))
  },
  /**
   * 查询公司近期充值订单
   * @param {*} limit 
   * @returns 
   */
  getCompanyBalanceTopUpOrderRecent (companyId, status, limit) {
    return axios.post(base.balance.getCompanyBalanceTopUpOrderRecent, utils.postParamsArrayToJsonString({ companyId, status, limit }))
  },
  /**
   * 个人充值
   */
  personalBalanceTopUp (channel, amount) {
    return axios.post(base.balance.personalBalanceTopUp, utils.postParamsArrayToJsonString({ channel, amount }))
  },
  /**
   * 公司充值
   */
  companyBalanceTopUp (channel, companyId, amount) {
    return axios.post(base.balance.companyBalanceTopUp, utils.postParamsArrayToJsonString({ channel, companyId, amount }))
  },
  /**
   * 重新支付
   */
  repaymentForBalanceTopUpOrder (orderId) {
    return axios.post(base.balance.repaymentForBalanceTopUpOrder, utils.postParamsArrayToJsonString({ orderId }))
  },
  /**
   * 个人钱包收支统计
   */
  personalWalletIncomeAndExpensesStatisticsMonth (startTime, endTime) {
    return axios.post(base.balance.personalWalletIncomeAndExpensesStatisticsMonth, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },
  /**
   * 公司钱包收支统计
   */
  companyWalletIncomeAndExpensesStatisticsMonth (companyId, startTime, endTime) {
    return axios.post(base.balance.companyWalletIncomeAndExpensesStatisticsMonth, utils.postParamsArrayToJsonString({ companyId, startTime, endTime }))
  },
}

export default balance